import _debug from "./services/debug"
import Controller from "./functions"

const Manager = function () {
    this.productionSystem = ["altstadtmanagement-spandau.de"];
};

Manager.prototype.init = function () {
    if (this.productionSystem.includes(location.host)) {
        _debug.output = false;
    }

    _debug.log("starting init");

    this.controller = new Controller();
    this.controller.init(this);
    this.handlePopstate();
};

Manager.prototype.handlePopstate = function() {
    const _self = this;

    window.addEventListener("popstate", (event) => {
        const canonical = document.querySelector("link[rel='canonical']").href,
            node = document.querySelector("section.section-ajax");

        Array.from(document.querySelectorAll('.ajax')).forEach(a => {
            a.parentElement.classList.remove("active");
        });

        if(event && event.state) {
            if(event.state.origin !== canonical) {
                location.reload();
            }
            else {
                const item = event.state.item || null, area = event.state.area || null, type = event.state.type || "url";

                // if(node !== null) {
                    // document.head.querySelector('meta[property="og:title"]').content;
                    if(type === "url") {
                        _self.controller.loadUrl(location.href,node,area,item);
                    }
                    else if(type === "download") {
                        const wrapper = document.querySelector("[data-download-list='" + area + "']"),
                            node = document.querySelector("[data-item-id='" + item + "']"),
                            toggle = document.querySelector("[data-accordion-area='" + area + "'] > button");

                        if(toggle.getAttribute("aria-expanded") !== "true") {
                            toggle.click();
                        }

                        _self.controller.getDownloadList(wrapper,node);
                    }
                // }
            }
        }
        else if(canonical !== window.location.href) {
            location.reload();
        }
        else {
            if(node) {
                node.classList.add("hidden");
            }
            else if(document.querySelector("[data-accordion-area] > button")) {
                const btn = document.querySelector("[data-accordion-area] > button");

                if(btn.getAttribute("aria-expanded") !== "true") {
                    btn.click();
                }
            }
        }
    });
};

const manager = new Manager();

document.addEventListener("DOMContentLoaded", function() {
    manager.init();
});